module.exports = __webpack_public_path__ + "static/media/building_118.427ace76.png";